/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "8fc8a6db30c717c8335819be4e396511762c4433";
